import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { RegistrationData } from '../models';

@Injectable({ providedIn: 'root' })
export class RegistrationService extends BaseService<RegistrationData> {
  constructor(http: HttpClient) {
    super(http, '/register');
  }
}